import moment from "moment-timezone"
import React, { useEffect, useState } from "react"
import { viewBooking } from "../../services/api/apiModule"

const ViewBookingPub = () => {
  const [showMap, setShowMap] = useState(false)
  const [loading, setLoading] = useState(true)
  const [bookingData, setBookingData] = useState({
    firstName: "ABC",
    lastName: "",
    bookingStatus: "pending",
    locationType: "mobile",
    location: "5680 Sherbrooke Street East, Montreal, QC, Canada",
    note: "",
    shortBookingId: "94918",
    bookingDate: "2025-12-20",
    bookingSlot: "12:10",
    booking: [
      {
        service: {
          serviceOption: "SUV-5 Seats",
          categoryName: "Ceramic Coating",
          categoryId: 0,
          packageName: "Diamond",
          packageId: 0,
          packageDescription: "",
          packagePrice: 1250,
          packageSalePrice: 1250,
          packagePriceType: "fixed",
          packagePriceRange: 1,
          _id: "69464515a3137291dae64b5c",
        },
        addonService: [
          {
            addonServiceId: 0,
            addonServiceName: "Level 3 Paint Correction",
            addonPrice: 225,
            addonSalePrice: 225,
            addonPriceType: "fixed",
            addonPriceRange: 1,
            _id: "69464515a3137291dae64b5d",
          },
          {
            addonServiceId: 1,
            addonServiceName: "Wheel Coating",
            addonPrice: 500,
            addonSalePrice: 500,
            addonPriceType: "fixed",
            addonPriceRange: 1,
            _id: "69464515a3137291dae64b5e",
          },
        ],
        images: [],
        servicePrice: 1250,
        addonTotalPrice: 725,
        totalPrice: 1975,
        _id: "69464515a3137291dae64b5b",
      },
    ],
    tax: 5,
    isWaterAvailable: true,
    isElectrictyAvailable: false,
    electricityBill: 15,
    serviceTotal: 1250,
    addonServiceTotal: 725,
    taxAmount: 79.75,
    subTotal: 1975,
    couponDiscountAmount: 395,
    giftCardDiscountAmount: 0,
    totalAmount: 1674.75,
  })

  const handleGetBooking = async (id) => {
    try {
      setLoading(true)
      const response = await viewBooking(id)
      if (response.success) {
        setBookingData(response.data || {})
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const id = window.location.pathname.split("/").pop()
    if (id) {
      handleGetBooking(id)
    }
  }, [])

  const InfoCard = ({ title, children }) => (
    <div className="bg-white rounded-2xl p-6 border border-yellow-100 shadow-[0_12px_28px_rgba(0,0,0,0.06)] hover:shadow-[0_18px_40px_rgba(234,179,8,0.22)] transition">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="space-y-3">{children}</div>
    </div>
  )

  const InfoRow = ({ label, value }) => (
    <div className="flex justify-between text-sm">
      <span className="text-gray-500">{label}</span>
      <span className="text-gray-900 font-medium text-right max-w-[65%]">
        {value}
      </span>
    </div>
  )

  const SummaryRow = ({ label, value, highlight }) => (
    <div className="flex justify-between text-sm my-2">
      <span className="text-gray-600">{label}</span>
      <span
        className={highlight ? "text-red-500 font-semibold" : "text-gray-900"}
      >
        ${value}
      </span>
    </div>
  )

  const UtilityCard = ({ type, available, extraText }) => {
    const isWater = type === "water"

    return (
      <div
        className={`rounded-2xl p-6 border transition-all duration-300
      ${
        available
          ? "bg-white border-yellow-200 shadow-[0_15px_35px_rgba(234,179,8,0.35)]"
          : "bg-gray-50 border-gray-200 shadow"
      }`}
      >
        <div className="flex items-center gap-4">
          {/* Icon */}
          <div
            className={`w-14 h-14 flex items-center justify-center rounded-full text-2xl
          ${
            available
              ? "bg-yellow-100 text-yellow-600 shadow-[0_0_18px_rgba(234,179,8,0.6)]"
              : "bg-gray-200 text-gray-500"
          }`}
          >
            <span
              className={`inline-block
              ${
                available
                  ? isWater
                    ? "animate-waterIcon"
                    : "animate-electricIcon"
                  : ""
              }`}
            >
              {isWater ? "💧" : "⚡"}
            </span>
          </div>

          {/* Content */}
          <div className="flex-1">
            <h4 className="text-lg font-semibold text-gray-900 capitalize">
              {type} Availability
            </h4>

            <p
              className={`text-sm font-medium ${
                available ? "text-green-600" : "text-red-500"
              }`}
            >
              {available ? "Available" : "Not Available"}
            </p>

            {extraText && (
              <p className="text-xs text-gray-500 mt-1">{extraText}</p>
            )}
          </div>
        </div>
      </div>
    )
  }

  const MiniMap = ({ locationType, address }) => {
    const shopAddress = "Boost Detailing, 5680 Dorset St, Burnaby, BC V5J 1L7"

    const mapUrl =
      locationType === "mobile"
        ? `https://www.google.com/maps/embed/v1/directions?key=AIzaSyC9U_W6NDorvK8-ani4lB0jtN21lYLi8d4&origin=${encodeURIComponent(
            shopAddress
          )}&destination=${encodeURIComponent(address)}`
        : `https://www.google.com/maps?q=${encodeURIComponent(
            shopAddress
          )}&output=embed`

    return (
      <div className="bg-white rounded-xl overflow-hidden shadow-[0_20px_45px_rgba(0,0,0,0.25)] border border-yellow-200">
        <iframe
          title="Mini Map"
          src={mapUrl}
          className="w-full h-52 rounded-xl"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    )
  }

  return (
    <div className="">
      <div className="min-h-screen bg-slate-100 px-4 py-6 md:p-10">
        <div className="max-w-6xl mx-auto space-y-8 animate-fadeIn">
          {loading ? (
            <>
              {/* Header Skeleton */}
              <div className="bg-white rounded-2xl p-6 border border-yellow-100 shadow">
                <Skeleton className="h-6 w-48 mb-2" />
                <Skeleton className="h-4 w-32" />
              </div>

              {/* Info Cards */}
              <div className="grid md:grid-cols-2 gap-6">
                <CardSkeleton />
                <CardSkeleton />
              </div>

              {/* Utility Skeletons */}
              <div className="grid md:grid-cols-2 gap-6">
                <UtilitySkeleton />
                <UtilitySkeleton />
              </div>

              {/* Services */}
              <ServiceSkeleton />
              <ServiceSkeleton />

              {/* Price Summary */}
              <CardSkeleton />
            </>
          ) : (
            <>
              {/* Header */}
              <div className="bg-white rounded-2xl p-6 shadow-[0_10px_30px_rgba(0,0,0,0.08)] border border-yellow-100 flex flex-col md:flex-row justify-between gap-4">
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">
                    Booking #{bookingData.shortBookingId}
                  </h1>
                  <p className="text-sm text-gray-500">
                    {moment
                      .tz(
                        `${bookingData.bookingDate} ${bookingData.bookingSlot}`,
                        "YYYY-MM-DD HH:mm",
                        "America/Vancouver"
                      )
                      .format("hh:mm A - DD MMM, YYYY")}
                  </p>
                </div>
                <div className="h-10 w-36 flex justify-center items-center rounded-3xl text-sm font-semibold bg-yellow-medium_dark text-white shadow-[0_0_12px_rgba(234,179,8,0.35)]">
                  <span className="animate-pulse">
                    {bookingData.bookingStatus.toUpperCase()}
                  </span>
                </div>
              </div>

              {/* Info Grid */}
              <div className="grid md:grid-cols-2 gap-6">
                <InfoCard title="Customer Details">
                  <InfoRow
                    label="Name"
                    value={`${bookingData.firstName} ${bookingData.lastName}`}
                  />
                  {/* <InfoRow label="Phone" value={bookingData.phoneNumber} />
              <InfoRow label="Email" value={bookingData.email} /> */}
                </InfoCard>

                <InfoCard title="Service Location">
                  <InfoRow label="Type" value={bookingData.locationType} />

                  {/* Address with hover map */}
                  <div className="relative group">
                    <InfoRow
                      label="Address"
                      value={
                        <span
                          onClick={() => {
                            setShowMap((prev) => !prev)
                          }}
                          className="cursor-pointer underline"
                        >
                          {bookingData.locationType === "mobile"
                            ? bookingData.location
                            : "5680 Dorset St, Burnaby, BC V5J 1L7"}
                        </span>
                      }
                    />

                    {/* Floating Mini Map */}
                    <div
                      className={`absolute left-0 top-full mt-3 w-full z-30
                 opacity-0 scale-y-0 origin-top
                 group-hover:opacity-100 group-hover:scale-y-100
                 transition-all duration-300 ease-out ${
                   showMap
                     ? "opacity-100 scale-y-100 translate-y-0"
                     : "opacity-0 scale-y-0 -translate-y-2 pointer-events-none"
                 }`}
                    >
                      <MiniMap
                        locationType={bookingData.locationType}
                        address={bookingData.location}
                      />
                    </div>
                  </div>
                </InfoCard>

                {/* Water & Electricity */}
                {bookingData.locationType === "mobile" && (
                  <div className="grid md:grid-cols-2 gap-6">
                    <UtilityCard
                      type="water"
                      available={bookingData.isWaterAvailable}
                      extraText={
                        bookingData.isWaterAvailable
                          ? "Customer provides water access"
                          : "Not provide water access"
                      }
                    />

                    <UtilityCard
                      type="electricity"
                      available={bookingData.isElectrictyAvailable}
                      extraText={
                        bookingData.isElectrictyAvailable
                          ? "Electric power available on site"
                          : `Extra charge applies: $${bookingData.electricityBill}`
                      }
                    />
                  </div>
                )}
              </div>

              {/* Services */}
              <div className="space-y-6">
                {bookingData.booking.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl p-6 border border-yellow-100 shadow-[0_12px_28px_rgba(234,179,8,0.18)] hover:shadow-[0_16px_40px_rgba(234,179,8,0.35)] hover:-translate-y-1 transition-all"
                  >
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">
                      {item.service.categoryName} — {item.service.packageName}
                    </h2>

                    <div className="flex justify-between text-gray-700 font-medium">
                      <span>{item.service.serviceOption}</span>
                      <span>${item.service.packagePrice}</span>
                    </div>

                    {item.addonService.length > 0 && (
                      <div className="mt-5 space-y-3">
                        <p className="text-sm text-gray-500">Add-on Services</p>
                        {item.addonService.map((addon, i) => (
                          <div
                            key={i}
                            className="flex justify-between items-center bg-yellow-50 rounded-xl px-4 py-3 shadow-inner"
                          >
                            <span className="text-gray-800 text-sm">
                              {addon.addonServiceName}
                            </span>
                            <span className="font-semibold text-gray-900">
                              ${addon.addonSalePrice}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Price Summary */}
              <div className="bg-white rounded-2xl p-6 border border-yellow-200 shadow-[0_20px_45px_rgba(234,179,8,0.25)]">
                <h2 className="text-xl font-bold text-gray-900 mb-4">
                  Price Summary
                </h2>

                <SummaryRow
                  label="Service Total"
                  value={bookingData.serviceTotal}
                />
                <SummaryRow
                  label="Add-ons Total"
                  value={bookingData.addonServiceTotal}
                />
                <SummaryRow label="Sub Total" value={bookingData.subTotal} />
                <SummaryRow
                  label="Coupon Discount"
                  value={`- ${bookingData.couponDiscountAmount}`}
                  highlight
                />
                <SummaryRow
                  label="Gift Card Discount"
                  value={`- ${bookingData.giftCardDiscountAmount}`}
                  highlight
                />
                <SummaryRow
                  label="Extra Power Charges"
                  value={bookingData.electricityBill}
                />
                <SummaryRow label="Tax" value={bookingData.taxAmount} />

                <div className="mt-6 pt-4 border-t border-gray-200 flex justify-between items-center">
                  <span className="text-lg font-semibold text-gray-900">
                    Total Payable
                  </span>
                  <span className="text-2xl font-bold text-yellow-600 drop-shadow">
                    ${bookingData.totalAmount}
                  </span>
                </div>
              </div>
            </>
          )}

          <div className="bg-white flex space-x-1 rounded-2xl p-6 border border-yellow-200 shadow-[0_20px_45px_rgba(234,179,8,0.25)]">
            <h2>PS.</h2>
            <p>If you need to reschedule or cancel, please text +1 (236) 992-8610 at least 12 hours in advance.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const Skeleton = ({ className }) => (
  <div
    className={`bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 
    animate-pulse rounded ${className}`}
  />
)

const CardSkeleton = () => (
  <div className="bg-white rounded-2xl p-6 border border-yellow-100 shadow">
    <Skeleton className="h-5 w-40 mb-4" />
    <Skeleton className="h-4 w-full mb-2" />
    <Skeleton className="h-4 w-3/4" />
  </div>
)

const UtilitySkeleton = () => (
  <div className="bg-white rounded-2xl p-6 border border-yellow-100 shadow flex gap-4">
    <Skeleton className="h-14 w-14 rounded-full" />
    <div className="flex-1">
      <Skeleton className="h-4 w-40 mb-2" />
      <Skeleton className="h-3 w-28" />
    </div>
  </div>
)

const ServiceSkeleton = () => (
  <div className="bg-white rounded-2xl p-6 border border-yellow-100 shadow">
    <Skeleton className="h-5 w-56 mb-4" />
    <Skeleton className="h-4 w-full mb-2" />
    <Skeleton className="h-4 w-2/3" />
  </div>
)

export default ViewBookingPub
